"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Logo = function Logo(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 14 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 14 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#FFF' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Search' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'Search' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "path-1",
    points: "0 0.116 13.925 0.116 13.925 13.9997 0 13.9997"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Tenant-User_My-Access_PAP's",
    transform: "translate(-1286.000000, -131.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Search",
    transform: "translate(1286.000000, 131.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask-2",
    fill: color
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1,5.6157 C1,3.1347 3.019,1.1157 5.5,1.1157 C7.981,1.1157 10,3.1347 10,5.6157 C10,8.0967 7.981,10.1157 5.5,10.1157 C3.019,10.1157 1,8.0967 1,5.6157 M13.775,13.1427 L9.706,9.1517 C10.512,8.1947 11,6.9617 11,5.6157 C11,2.5827 8.532,0.1157 5.5,0.1157 C2.468,0.1157 0,2.5827 0,5.6157 C0,8.6477 2.468,11.1157 5.5,11.1157 C6.826,11.1157 8.045,10.6437 8.996,9.8577 L13.074,13.8577 C13.172,13.9517 13.299,13.9997 13.425,13.9997 C13.555,13.9997 13.684,13.9497 13.782,13.8507 C13.976,13.6537 13.972,13.3357 13.775,13.1427",
    id: "Fill-1",
    fill: color,
    mask: "url(#mask-2)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.0263637,5.6278416 C2.01269363,5.58255248 2,5.5146188 2,5.46736059 C2,4.18843529 2.49700463,3.29742112 3.36603041,3.02273278 C3.62185598,2.94101546 3.89721022,3.08672827 3.97727776,3.34566388 C4.05832174,3.60459949 3.91576245,3.88125692 3.65798402,3.96297424 C3.02525513,4.16283709 2.97643346,5.16510496 2.97643346,5.46736059 C2.97643346,5.46736059 2.93835256,6 2.49407533,6 C2.05077454,6 2.0263637,5.6278416 2.0263637,5.6278416",
    id: "Fill-4",
    fill: color
  })))));
};
Logo.propTypes = _index.iconProps;
var _default = Logo;
exports["default"] = _default;